import type { Entity, LastEvaluatedKey, QueryResult } from '@data-terminal/shared-models/common';

export const ToolPart = {
    PUNCHING: 'PUNCHING',
    STRIPPING: 'STRIPPING',
} as const;

export type ToolPart = (typeof ToolPart)[keyof typeof ToolPart];

export type ToolUsage = {
    toolId: string;
    toolPart: ToolPart;
    setupCount: number;
    punchCount: number;
    machineIds: readonly string[];
    grammages: readonly number[];
    isNew?: boolean;
};

export type ToolUsageEntity = ToolUsage & Entity;

export type ToolUsagePageRequest = {
    toolId?: string;
    limit: number;
    startKey?: LastEvaluatedKey | null;
};

export type ToolUsagePage = QueryResult<ToolUsageEntity>;
